import Api from '~/config/Api'
const endpoint = Api.clubs

export default {
  async fetch (payload) {
    const { data } = await useApi(endpoint, payload)

    return data
  },

  async detail (slug) {
    const detailEndpoint = endpoint + '/' + slug
    const { data } = await useApi(detailEndpoint)

    return data
  },

  async popular () {
    const { data } = await useApi(endpoint, {
      query: {
        isPopular: true,
        limit: 99
      }
    })

    return data
  },

  async tournament (tournamentSlugs = []) {
    const { data } = await useApi(endpoint, {
      query: {
        tournaments: tournamentSlugs,
        limit: 99
      }
    })

    return data
  }
}
